import React from "react";
import { Location, Navigate, Route, Routes, useLocation } from "react-router-dom-v5-compat";
import { useNutritionFlags } from "../../../../hooks/useNutritionFlags";
import { getLink } from "../../../NavUtils";
import { RoleRoute } from "../../ProtectedRoutes";
import { NavLink } from "../../SecondaryNav/BreadCrumbs";
import { SecondaryNavLayout, SecondaryNavLayoutProps } from "../../SecondaryNav/SecondaryNavLayout";
import MenuItemCreatePage from "./MenuItemCreatePage";
import MenuItemEditPage from "./MenuItemEditPage";
import { kitchenLink, kitchenMenuItemsLink, NAV_ORG_KITCHEN_MENU_ITEMS, NAV_ORG_MENU_ITEM } from "./KitchenPaths";

const getNavOrgMenuItemLink = (location?: Location) => {
  if (!location?.pathname.includes("/create") && location?.pathname !== NAV_ORG_MENU_ITEM) {
    const id = location?.pathname.replace(`${NAV_ORG_MENU_ITEM}/`, "");
    return getLink("Edit Menu Item", `${NAV_ORG_MENU_ITEM}/${id}`);
  }

  return getLink("Create Menu Item", NAV_ORG_MENU_ITEM);
};

const getSecondaryNavLayoutProps = (current: NavLink): SecondaryNavLayoutProps => ({
  name: "Menu Item",
  current,
  breadCrumbs: [kitchenLink, kitchenMenuItemsLink],
  tabs: [],
  enableAthleteSearch: true,
});

export const MenuItemRouter = () => {
  const location = useLocation();
  const { isRecipeAndMenuItemRedesignEnabled } = useNutritionFlags();
  const current = getNavOrgMenuItemLink(location);
  const secondaryNavLayoutProps = getSecondaryNavLayoutProps(current);

  if (!isRecipeAndMenuItemRedesignEnabled) {
    return <Navigate to={NAV_ORG_KITCHEN_MENU_ITEMS} replace />;
  }

  return (
    <Routes>
      <Route element={<SecondaryNavLayout {...secondaryNavLayoutProps} />}>
        <Route element={<RoleRoute roles={["dietitian", "chef", "foodmanager", "nonRdAdmin"]} />}>
          <Route index element={<MenuItemCreatePage />} />
          <Route path={"/create"} element={<MenuItemCreatePage />} />
          <Route path={"/:id"} element={<MenuItemEditPage />} />
        </Route>
      </Route>
    </Routes>
  );
};
